import { useEffect, useSyncExternalStore } from 'react';
import { getCurrentActorScope } from '../../api/client';
import { subscribeAttempts, attemptStoreVersion, setAttemptScope } from './unresolvedChange';

/**
 * Re-renders an editor whenever the record of an unresolved HQ change changes (including when the signed-in actor becomes known), and makes sure the record is scoped to the
 * current actor + environment. Until the actor is known nothing is shown as recovered and nothing is replayed.
 */
export function useAttemptStore(): number {
  useEffect(() => { let live = true; getCurrentActorScope().then((s) => { if (live) setAttemptScope(s); }); return () => { live = false; }; }, []);
  return useSyncExternalStore(subscribeAttempts, attemptStoreVersion);
}
